<script setup>
import AnSparkline from "./AnSparkline.vue";

defineProps({
  label: { type: String, required: true },
  value: { type: [String, Number], required: true },
  unit: { type: String, default: "" },
  sub: { type: String, default: "" },
  spark: { type: Array, default: null },
  sparkColor: { type: String, default: "#38bdf8" },
  sparkFill: { type: String, default: "rgba(56,189,248,.16)" },
  delta: { type: String, default: "" },
  deltaDir: { type: String, default: "up" }, // up | down
  hero: { type: Boolean, default: false },
});
</script>

<template>
  <div class="an-kpi" :class="{ 'an-kpi--hero': hero }">
    <div class="an-kpi__label">
      {{ label }}
    </div>
    <div class="an-kpi__value">{{ value }}<small v-if="unit">{{ unit }}</small></div>
    <div class="an-kpi__foot">
      <AnSparkline v-if="spark && spark.length" :values="spark" :color="sparkColor" :fill="sparkFill" />
      <span v-else-if="sub" class="an-kpi__sub">{{ sub }}</span>
      <span v-if="delta" class="an-delta" :class="`an-delta--${deltaDir}`">{{ delta }}</span>
      <span v-else-if="spark && spark.length && sub" class="an-kpi__sub">{{ sub }}</span>
    </div>
  </div>
</template>
